import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { storage } from '@/shared/utils/storage';
import { clearSentPushEndpoint } from '@/shared/push/sentEndpoint';
import { clearCachedUser } from './userCache';

interface LoginState {
  accessToken: string | null;
  refreshToken: string | null;
  isLoggedIn: boolean;
}

const accessTokenLS = storage.get('access_token');
const refreshTokenLS = storage.get('refresh_token');

const initialState: LoginState = {
  accessToken: accessTokenLS,
  refreshToken: refreshTokenLS,
  isLoggedIn: !!accessTokenLS,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setTokens(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken?: string }>
    ) {
      state.accessToken = action.payload.accessToken;
      if (action.payload.refreshToken)
        state.refreshToken = action.payload.refreshToken;
      state.isLoggedIn = true;

      storage.set('access_token', state.accessToken!);
      if (state.refreshToken) storage.set('refresh_token', state.refreshToken);

      // Сессия новая — профиль в кэше от прошлой. Иначе до ответа сервера
      // в шапке профиля мелькнуло бы имя предыдущего входа
      clearCachedUser();
    },
    clearTokens(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.isLoggedIn = false;

      storage.remove('access_token');
      storage.remove('refresh_token');
      clearCachedUser();
      // Логаут снял токен с девайса: следующий вход должен отправить подписку
      clearSentPushEndpoint();
    },
  },
});

export const { setTokens, clearTokens } = loginSlice.actions;
export default loginSlice.reducer;
